// extracted by mini-css-extract-plugin
export var buttonText = "care-image-text-module--buttonText--d2a9c";
export var careImageText = "care-image-text-module--careImageText--f8764";
export var careImageTextContainer = "care-image-text-module--careImageTextContainer--03c60";
export var contentContainer = "care-image-text-module--contentContainer--17b28";
export var desktopButton = "care-image-text-module--desktopButton--5b43a";
export var greenBackground = "care-image-text-module--greenBackground--ad026";
export var icon = "care-image-text-module--icon--6dd25";
export var iconContainer = "care-image-text-module--iconContainer--3626f";
export var image = "care-image-text-module--image--8970b";
export var imageContainer = "care-image-text-module--imageContainer--eb4f3";
export var inCarousel = "care-image-text-module--inCarousel--b84e4";
export var mobileButton = "care-image-text-module--mobileButton--830f9";
export var reversed = "care-image-text-module--reversed--87e72";
export var text = "care-image-text-module--text--5af39";
export var title = "care-image-text-module--title--e28d8";
export var whiteBackground = "care-image-text-module--whiteBackground--f5591";